export const REPORT_ICONS_URL_PREFIX = 'https://flipdishdashboardicons.imgix.net/';
